import { render, staticRenderFns } from "./StockShipping.vue?vue&type=template&id=6732326f&scoped=true&"
import script from "./StockShipping.vue?vue&type=script&lang=js&"
export * from "./StockShipping.vue?vue&type=script&lang=js&"
import style0 from "./StockShipping.vue?vue&type=style&index=0&id=6732326f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732326f",
  null
  
)

export default component.exports